/* eslint-disable no-console */
import P from '@leverege/promise';
import { Project, System } from '@leverege/api-redux';

/**
 * OnLogged, this will load blueprints, networks*, roles, and enums into redux
 * 
 * * TBD
 */
export default {
  id: 'molten.ApiLogin',
  sort: -100,
  onLoggedIn: async molten => {
    const store = molten.get('store');
    const api = molten.get('api');
    const prjId = api.options.projectId;
    const sysId = api.options.systemId;
    await P.all({
      blueprints: () => store.dispatch(Project(prjId).blueprints().list()),
      roles: () => store.dispatch(Project(prjId).roles().list({
        includePermissions: true,
        scope: 'custom'
      })),
      enums: () => store.dispatch(Project(prjId).enums().list()),
      systemEnums: () => store.dispatch(System(sysId).resourceEnums().list())
      // TODO: MISSING: networks : () => store.dispatch( Project( prjId ).networks().list() )
    }, {
      handleReject: true
    }).then(r => {
      Object.keys(r).forEach(key => {
        const result = r[key];
        if (result instanceof Error) {
          console.error(`Molten: ApiLoad failed to read ${key}`, result);
        }
      });
    });
  },
  onLoggedOut: async molten => {
    // Todo: remove all data loaded in onLoggedIn
  }
};